// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"466":"d7816425","787":"64ffad1d"}[chunkId] + ".chunk.js";
};